import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { ArrowRight, Code2 } from 'lucide-react'
import { buttonVariants } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import Callout from './Callout'

const ApiCallout = () => {
  const { t } = useTranslation()

  return (
    <Callout
      icon={Code2}
      title={t('homepage.api-title')}
      description={t('homepage.api-description')}
    >
      <Link
        to='/api'
        className={cn(buttonVariants({ variant: 'outline' }), 'gap-2')}
      >
        {t('homepage.api-link')}
        <ArrowRight className='h-4 w-4' />
      </Link>
    </Callout>
  )
}

export default ApiCallout
